import swiper from 'swiper'

const gallerySlider = () => {
    if (!!document.querySelector('.is-style-slider-gallery')) {
        document.querySelectorAll('.is-style-slider-gallery').forEach(gallery => {
           
            replaceGalleryClasses(gallery)
            createNav(gallery)
            
            const slider = new swiper(gallery, {
                slidesPerView: 1.5,
                spaceBetween: 100,

                breakpoints: {
                    320: {
                        slidesPerView: 1.1,
                        spaceBetween: 20,
                    },

                    1024: {
                        slidesPerView: 1.5,
                        spaceBetween: 160,
                    }
                }
            })

            gallery.querySelector('.all-slides').innerText = gallery.querySelectorAll('.swiper-slide').length > 9 ?`/${gallery.querySelectorAll('.swiper-slide').length}` : `/0${gallery.querySelectorAll('.swiper-slide').length}`
            gallery.querySelector('.current-slide').innerText = '01'


            activeUnactiveNav({isBeginning: true}, gallery)


            slider.on('slideChange', function (e) {
                gallery.querySelector('.current-slide').innerText = e.activeIndex+1 > 9 ? e.activeIndex+1 : `0${e.activeIndex+1}`
                activeUnactiveNav(e, gallery)
            });


            gallery.querySelector('.ia-custom-navigation__swiper-button-next').addEventListener('click', function(e) {
                e.preventDefault()
                slider.slideNext()
            })
            gallery.querySelector('.ia-custom-navigation__swiper-button-prev').addEventListener('click', function(e) {
                e.preventDefault()
                slider.slidePrev()
            })
        });
    }
}





function replaceGalleryClasses(gallery) {
    gallery.classList.remove(...gallery.classList)
    gallery.classList.add('swiper-container', 'is-style-slider-gallery', 'ia-block-slider-gallery', 'alignfull')

    const wrapper = document.createElement('div')
    wrapper.setAttribute('class', 'swiper-wrapper')

    const arraySlide = []
    gallery.querySelectorAll('.wp-block-image').forEach(slide => {
        slide.classList.add('swiper-slide')
        slide.classList.remove('wp-block-image')
        arraySlide.push(slide)
        slide.remove()
    })

    arraySlide.forEach(slide => wrapper.append(slide))
    gallery.append(wrapper)
}





function createNav(gallery) {
    const navContent = document.createElement('div')
    navContent.setAttribute('class', 'ia-custom-navigation')

    const navigation = [
        {
            classNav: 'ia-custom-navigation__swiper-button-prev',
            text: { fr: 'Précédent', en: 'Previous', de: 'Vorherige' }
        },
        {
            classNav: 'ia-custom-navigation__swiper-button-next',
            text: { fr: 'Suivant', en: 'Next', de: 'Weiter' }
        }
    ]

    navigation.forEach((elem, i, a) => {
        const link = document.createElement('a')
        link.setAttribute('class', elem.classNav)
        link.setAttribute('href', '#')
        const span = document.createElement('span')
        span.innerText = elem.text[document.querySelector('html').lang]
        link.append(span)
        navContent.append(link)
        if (i === 0) {
            const span = document.createElement('span')
            span.innerHTML = '<span class="current-slide"></span><span class="all-slides"></span>'
            link.insertAdjacentElement('afterend', span)
        }
    })
    
    gallery.appendChild(navContent)
}




function activeUnactiveNav(e, gallery) {
    if (e.isEnd) {
        gallery.querySelector('.ia-custom-navigation__swiper-button-next').classList.add('unactive')
    } else {
        gallery.querySelector('.ia-custom-navigation__swiper-button-next').classList.remove('unactive')
    }

    if (e.isBeginning) {
        gallery.querySelector('.ia-custom-navigation__swiper-button-prev').classList.add('unactive')
    } else {
        gallery.querySelector('.ia-custom-navigation__swiper-button-prev').classList.remove('unactive')
    }
}


export {gallerySlider, activeUnactiveNav}